module.exports = __webpack_public_path__ + "static/team_roberta-8f4d694706776f52a87fa6f4949989bc.jpg";